
import { useState } from 'react';
import { Settings, Mail, Bell, Shield, Globe } from 'lucide-react';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    { id: 'general', label: 'General', icon: Settings },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'email', label: 'Email', icon: Mail },
    { id: 'security', label: 'Security', icon: Shield },
    { id: 'localization', label: 'Localization', icon: Globe },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-8">System Settings</h1>

      <div className="flex space-x-4 border-b mb-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center px-4 py-2 border-b-2 ${
              activeTab === tab.id
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <tab.icon className="w-4 h-4 mr-2" />
            {tab.label}
          </button>
        ))}
      </div>

      <div className="space-y-6">
        {activeTab === 'general' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">General Settings</h3>
            <p className="text-gray-600">
              Configure general application settings and preferences.
            </p>
          </div>
        )}

        {activeTab === 'email' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">Email Configuration</h3>
            <p className="text-gray-600">
              Configure email notifications and SMTP settings.
            </p>
          </div>
        )}

        {activeTab === 'localization' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">Localization Settings</h3>
            <p className="text-gray-600">
              Configure language, timezone, and currency settings.
            </p>
          </div>
        )}

        {activeTab === 'notifications' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">Notification Settings</h3>
            <p className="text-gray-600">
              Configure how and when notifications are sent.
            </p>
          </div>
        )}

        {activeTab === 'security' && (
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">Security Settings</h3>
            <p className="text-gray-600">
              Configure security settings and access controls.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsPage;
